import React from 'react';
import styles from './LoadingDetailsPageCard.module.css';
import { Card } from '../../../../components/Card';
import styled from 'styled-components';

const Container = styled.div`
width: 100%;
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    height: 300px;
  }
`;

const CardPlaceholder = () => <div className={styles.cardPlaceholder} />;

const createPlaceholders = count => Array.from({ length: count }, (_, index) => <CardPlaceholder key={index} />);

const LoadingDetailsPageCard = () => {
  return (
    <Container>
      <Card className='vehicle-info-card info-card'>{createPlaceholders(5)}</Card>
    </Container>
  );
};

export default LoadingDetailsPageCard;
